<div class="flex justify-start mb-3">
	<div class="flex flex-col">
		<p class="text-white font-medium text-xs">{{ user?.name }}</p>
		<p class="text-[#BBBBBB] text-[10px] font-[100]">Role: {{ user?.role }}</p>
	</div>
</div>
